export const VIEWS_CONFIG = {
  getVehicles: 'vehicle/list-vehicles',
  getFilters: 'vehicle/filter-data',
  getCarDetail: 'vehicle/vehicle-details',
  pickUpLocationAutocomplete: 'vehicle/pickup-location-suggestions',
  getDepositOptions: 'booking/get-deposit-options',
  getExtrasOptions: 'vehicle/list-extras',
  getBookingTotal: 'booking/get-booking-summary',
  createBooking: 'booking/create-booking',
  updateProfile: 'onboarding/customer/update-profile',
  getBookingDetail: 'booking/get-booking-details',
  uploadInovicePdf: 'booking/upload-booking-documents',
  validatePromoCode: 'promo-codes/validate',
  getBookings: 'booking/get-user-booking',
  cancelBooking: 'booking/request-cancellation',
  rebook: 'vehicle/rebook-vehicle-search',
  rentalAgreementGeneration: 'booking/generate-rental-agreement-pdf',
  createSession: 'payments/cybersource/create-session',

  faqs: [
    {
      question: 'How can I book a car?',
      answer:
        'Customers can browse available vehicles, select rental duration, add extras, and confirm the booking.',
    },
    {
      question: 'What documents are required for booking?',
      answer:
        'A valid QID and Driving License must be uploaded and verified before a vehicle can be delivered.',
    },
    {
      question: 'Can I cancel or modify my booking?',
      answer:
        'Yes, cancellations are allowed while the booking is in Booked status. Modifications are subject to availability.',
    },
    {
      question: 'What payment methods are supported?',
      answer:
        'Customers can pay using credit/debit cards or other available payment methods listed at checkout.',
    },
    {
      question: 'How do I track my booking status?',
      answer:
        'All bookings can be tracked under the “My Bookings” section, with statuses like Booked, Picked, Pending Handover, Cancel Request, Returned, etc.',
    },
    {
      question: 'What happens if my KYC is not verified?',
      answer: 'Vehicles will not be delivered until your documents are fully verified by Admin.',
    },
  ],
  kycDocColorCodes: {
    pending: {
      color: '#E18D44',
      backgroundColor: '#FFF2E7',
      borderColor: '#FFF2E7',
    },
    verified: {
      color: '#41C694',
      backgroundColor: '#EFFAF6',
      borderColor: '#EFFAF6',
    },
    rejected: {
      color: '#E54A48',
      backgroundColor: '#FFF5F4',
      borderColor: '#FFF5F4',
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    missing_document: {
      color: '#AD6FEA',
      backgroundColor: '#F3E7FF',
      borderColor: '#F3E7FF',
    },
  },
};
